import { Container, Row } from "reactstrap";
import { BonusUi, ScrollableTitle } from "../../../constants";
import BadgesScrollbar from "./BadgesScrollbar";
import BothSideScrollbar from "./BothSideScrollbar";
import CustomScrollbar from "./CustomScrollbar";
import HorizontalScrollbar from "./HorizontalScrollbar";
import ProfileScrollable from "./ProfileScrollable";
import ScrollableContent from "./ScrollableContent";
import SmallSizeScroll from "./SmallSizeScroll";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const ScrollableContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ScrollableTitle} parent={BonusUi} />
      <Container fluid >
        <Row>
          <CustomScrollbar />
          <SmallSizeScroll />
          <BadgesScrollbar />
          <ProfileScrollable />
          <ScrollableContent />
          <HorizontalScrollbar />
          <BothSideScrollbar />
        </Row>
      </Container>
    </>
  );
};

export default ScrollableContainer;
